export default "__VITE_ASSET__C2WVcy9j__"